import script from "./Viewport2D.vue?vue&type=script&setup=true&lang=js"
export * from "./Viewport2D.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__